import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " Lista de Notificaciones ", -1)
const _hoisted_5 = { class: "card-body" }

export function render(_ctx, _cache) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DataTable, {
            value: _ctx.notificaciones,
            stripedRows: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "timestamp",
                header: "Fecha"
              }, {
                body: _withCtx((prop) => [
                  _createTextVNode(_toDisplayString(_ctx.formattedDate(prop.data.timestamp)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "content",
                header: "Mensaje"
              }),
              _createVNode(_component_Column, { header: "Acciones" }, {
                body: _withCtx((prop) => [
                  (prop.data.status == 1)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "me-2",
                        icon: "fa fa-info-circle",
                        title: "Ver Información",
                        severity: "success",
                        onClick: $event => (_ctx.checkNotificacion(prop.data))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (prop.data.status == 2)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "me-2",
                        icon: "fa fa-trash",
                        severity: "danger",
                        title: "Eliminar Notificación",
                        onClick: $event => (_ctx.deleteNotification(prop.data.uid))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ])
  ]))
}